import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../login/login.service';
import { CtbCcService } from '../../../catalogo/ctb-cc/ctb-cc.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-estado-resultados-cc',
  templateUrl: './estado-resultados-cc.component.html',
  styleUrls: ['./estado-resultados-cc.component.css']
})
export class EstadoResultadosCcComponent implements OnInit {
  public mes_inicial: number;
  public mes_final: number;
  public ano: number;
  public cc_id: number;
  public anos: any[] = [];
  public meses: any[] = [
    { numero: 1, nombre: 'enero' },
    { numero: 2, nombre: 'febrero' },
    { numero: 3, nombre: 'marzo' },
    { numero: 4, nombre: 'abril' },
    { numero: 5, nombre: 'mayo' },
    { numero: 6, nombre: 'junio' },
    { numero: 7, nombre: 'julio' },
    { numero: 8, nombre: 'agosto' },
    { numero: 9, nombre: 'septiembre' },
    { numero: 10, nombre: 'octubre' },
    { numero: 11, nombre: 'noviembre' },
    { numero: 12, nombre: 'diciembre' }];
  public reporte: any = { titulo: '', meses: [] };
  public select_cc: any[] = [];

  constructor(private ctbCcService: CtbCcService, private loginService: LoginService) { }

  ngOnInit(): void {
    this.cc_id = 0;
    this.mes_inicial = 1;
    this.mes_final = new Date().getMonth()+1;
    this.cargarAnos();
    this.cargarSelectCc();
    this.cargarReporte(false);
  }
  cargarSelectCc() {

    this.ctbCcService.selectByMesAnioEmp(0, 0, this.loginService.empresa).subscribe(
      response => {
        this.cc_id = 0;
        this.select_cc = response.contenido;
      }
    );
  }
  cargarAnos() {
    const ejercicios = JSON.parse(String(localStorage.getItem('ejercicios')));
    for (let x = 0; x < ejercicios.length; x++) {
      this.anos.push(ejercicios[x].anio);
    }
    this.ano = this.loginService.ejercicio;
    // this.cargarReporte();
  }

  cargarReporte(actualizar_select: boolean) {
    this.ctbCcService.getReporteEstadoResultadosCc(this.mes_inicial, this.mes_final, this.ano, this.cc_id, this.loginService.empresa).subscribe(
      response => {
        this.reporte = response.contenido;
        console.log(this.reporte);
        if (actualizar_select) {
          this.cargarSelectCc();
        }
      }
    );
  }

  exportAsXLSX() {
    this.ctbCcService.getRepEstResXlsx(this.mes_inicial, this.mes_final, this.ano, this.cc_id, this.loginService.empresa).subscribe(
      response => {
        console.log(response);
        const a = document.createElement('a');
        const titulo_pdf = 'ER-' + this.mes_inicial + '-' + this.mes_final + '-' + this.ano;
        a.href = URL.createObjectURL(response);
        a.download = titulo_pdf + '.xls';
        document.body.appendChild(a);
        a.click();
      }
    );
  } 
  exportAsPdf() {
    this.ctbCcService.getRepEstResPdf(this.mes_inicial, this.mes_final, this.ano, this.cc_id, this.loginService.empresa).subscribe(
      response => {
        console.log(response);
        const a = document.createElement('a');
        const titulo_pdf = 'ER-' + this.mes_inicial + '-' + this.mes_final + '-' + this.ano;
        a.href = URL.createObjectURL(response);
        a.download = titulo_pdf + '.pdf';
        document.body.appendChild(a);
        a.click();
      }
    );
  }
}
